import React from 'react'

import classes from './ButtonLightRed.module.css';

const ButtonLight = props => (
  <button
    onClick={props.onClick}
    className={classes.buttonLightRed}
  >
    {props.children}
  </button>
)

export default ButtonLight;
